export default __webpack_public_path__ + "149dc2452626386bcceb22ba959429b8.gif";